import { useStaticQuery, graphql } from 'gatsby'

const useLogo = () => {
    const { logo, logoDark } = useStaticQuery(logoQuery)
    return {logo, logoDark}
  }

const logoQuery = graphql`
  query LogoQuery {
    logo: file(
      absolutePath: { regex: "/logo.(jpeg|jpg|gif|png)/" }
      sourceInstanceName: { eq: "images" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width: 150
          layout: CONSTRAINED
          quality: 100
          placeholder: NONE
        )
      }
    }
    logoDark: file(
      absolutePath: { regex: "/logo-dark.(jpeg|jpg|gif|png)/" }
      sourceInstanceName: { eq: "images" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width: 150
          layout: CONSTRAINED
          quality: 100
          placeholder: NONE
        )
      }
    }
  }
`

export default useLogo